module.exports = __webpack_public_path__ + "static/media/icon-building.76517615.svg";